<template>
  <v-container fluid>
    <v-dialog v-model="showDialog" width="800px">
      <v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeModal"> Fechar </v-btn>
        </v-card-actions>
        <v-card-title>
          <span class="headline">Empresa</span>
        </v-card-title>

        <v-card-text>
          <v-form @submit.prevent="submit" ref="form" v-model="valid">
            <v-row class="mx-4">
              <v-text-field
                label="Nome"
                v-model="enterpriseEdit.name"
                :rules="nameRules"
              ></v-text-field>
            </v-row>

            <v-row class="mx-4">
              <v-text-field
                label="CNPJ"
                v-model="enterpriseEdit.cnpj"
                v-mask="'##.###.###/####-##'"
              ></v-text-field>
            </v-row>

            <v-row class="mx-4">
              <v-text-field
                label="Inscrição estadual"
                v-model="enterpriseEdit.ie"
                v-mask="'###.###.###.###'"
              ></v-text-field>
            </v-row>
            <v-row class="mx-4">
              <v-text-field
                label="Email padrão"
                v-model="enterpriseEdit.email"
              ></v-text-field>
            </v-row>
            <v-row class="mx-4">
              <v-text-field
                label="Fone"
                 v-mask= "(enterpriseEdit.phone.length<=13)?'(##)####-####':'(##)#####-####'  "
                v-model="enterpriseEdit.phone"
              ></v-text-field>
            </v-row>

            <v-row class="mb-4 mx-4">
              <autocomplete-city
                @changed="changedCity"
                :preSearch="enterpriseEdit.cityName"
              ></autocomplete-city>
            </v-row>

            <v-row class="ma-4">
              <v-text-field
                label="Endereço"
                hide-details="auto"
                v-model="enterpriseEdit.streetAddress"
              ></v-text-field>
            </v-row>
            <v-row class="ma-4">
              <v-text-field
                label="CEP"
                hide-details="auto"
                v-mask="'##.###-###'"
                @blur="updatedZipCode"
                v-model="enterpriseEdit.zipCode"
              ></v-text-field>
            </v-row>

            <v-row class="ma-4">
              <v-text-field
                label="Número"
                hide-details="auto"
                v-model="enterpriseEdit.streetAddressNumber"
              ></v-text-field>
            </v-row>
            <v-row class="ma-4">
              <v-text-field
                label="Complemento"
                hide-details="auto"
                v-model="enterpriseEdit.streetAddressNumber2"
              ></v-text-field>
            </v-row>
            <v-row class="ma-4">
              <v-text-field
                label="Bairro"
                hide-details="auto"
                v-model="enterpriseEdit.neighborhood"
              ></v-text-field>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn class="secondary" @click="closeModal"> Cancelar</v-btn>
          <v-spacer></v-spacer>

          <v-btn class="primary" @click="save(enterpriseEdit)">
            <v-progress-circular
              v-show="saving"
              indeterminate
              color="white"
            ></v-progress-circular>
            <span v-show="!saving"> Salvar</span></v-btn
          >
        </v-card-actions>

        <v-card-text> </v-card-text>
      </v-card>
    </v-dialog>

    <v-row class="ma-4">
      <div class="text-h3" :class="`blue-grey--text text--darken-2`" color="">
        Empresas
      </div>
      <v-spacer></v-spacer>
      <v-btn class="primary" v-if="!loading" @click="newEnterprise">
        +Novo
      </v-btn>
    </v-row>

    <v-progress-circular
      v-show="loading"
      indeterminate
      color="primary"
    ></v-progress-circular>

    <v-card v-if="!loading">
      <v-toolbar color="primary" dark>
        <v-spacer></v-spacer>
        <v-toolbar-title style="color: white; font-weight: bold">
          Empresas
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-text>
        <v-simple-table class="ma-4">
          <template v-slot:default>
            <thead>
              <tr>
                <th style="width: 100px">Delete</th>
                <th style="width: 300px" class="text-left">Nome</th>
                <th class="text-left">Email</th>
                <th class="text-left">Telefone</th>
                <th class="text-left">Cidade</th>
                <th style="width: 100px">Editar</th>
                <!-- <th class="">Editar</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in enterprises" :key="item.id">
                <td class="text-left">
                  <!-- <v-btn @click="editEnterprise(item, index)" class="secondary">
                    <v-icon>mdi-pencil-outline</v-icon></v-btn
                  > -->
                </td>
                <td>{{ item.name }}</td>
                <td>{{ item.email }}</td>
                <td>{{ item.phone }}</td>
                <td>{{ item.cityName }}</td>
                 <td class="text-left">
                  <v-btn @click="editEnterprise(item, index)" class="secondary">
                    <v-icon>mdi-pencil-outline</v-icon></v-btn
                  >
                 </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import AutocompleteCity from "../../component/AutocompleteCity.vue";
import hebelApi from "../../../../libraries/hebel/hebelApi";
export default {
  name: "Enterprises",
  components: {
    AutocompleteCity,
  },
  data() {
    return {
      users: [],
      enterprises: [],
      loading: true,
      showDialog: false,
      showDialog2: false,
      saving: false,
      show1: false,
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 6 || "Min 6 characters",
        emailMatch: () => `The email and password you entered don't match`,
      },
      enterpriseEdit: {
        name: "",
        cnpj: "",
        ie: "",
        phone: "",
        address: "",
        zipCode: "",
        cityName: "",
      },
      valid: true,

      nameRules: [
        (v) => !!v || "Nome é obrigatório",
        // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
    };
  },
  async mounted() {
    this.enterprises = await hebelApi.enterprises.getAll();
    this.enterprises.sort(function (a, b) {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });

    //alert("sorted")

    this.loading = false;
  },

  computed: {
    optionsEnterprises: function () {
      var options = [];
      if (this.enterprises) {
        for (var e = 0; e < this.enterprises.length; e++)
          options.push({
            value: this.enterprises[e],
            text: this.enterprises[e].name,
          });
      }
      return options;
    },
  },

  methods: {
    async updatedZipCode() {
      // alert("test>:" + this.site.zipCode);

      var info = await this.$globalFunctions.searchZipCode(
        this.enterpriseEdit.zipCode
      );
      //var info = await this.$globalFunctions.searchZipCode("13.026-340");

      this.search = info.cityName;
      this.enterpriseEdit.cityName = info.cityName;

      //alert(JSON.stringify(info));
      this.enterpriseEdit.streetAddress = info.streetAddress;
      this.enterpriseEdit.neighborhood = info.neighborhood;
      //this.site.
    },

    changedCity(cityName) {
      this.enterpriseEdit.cityName = cityName;
    },
    async save(item) {
      this.saving = true;
      if (item.id) {
        await this.saveEditingEnterprise(item);
      } else {
        await this.addEnterprise(item);
      }
      this.saving = false;
      this.showDialog = false;
      this.clearEnterprise();

      //this.$refs.form.reset()
      this.$forceUpdate();
    },

    async saveEditingEnterprise(item) {
      console.log("saveEditingEnterprise");
      //var ans = await this.$dao.saveEnterprise(item);
      var ans = await hebelApi.enterprises.upsert(item);

      var index;
      for (var i = 0; i < this.enterprises.length; i++) {
        if (this.enterprises[i].id == item.id) index = i;
      }
      this.enterprises.splice(index, 1);
      this.enterprises.unshift(item);
    },

    clearEnterprise() {
      this.enterpriseEdit = {
        name: "",
        cnpj: "",
        ie: "",
        phone: "",
        address: "",
        zipCode: "",
        cityName: "",
      };
    },
    newEnterprise() {
      this.enterpriseEdit = {
        name: "",
        cnpj: "",
        ie: "",
        phone: "",
        address: "",
        zipCode: "",
        cityName: "",
        quoteProfiles: [
          {
            description: "completo",
            formula: {
              script: "",
              fields: [],
            },
            formulaDocument: {
              script: "",
              fields: [],
              images: [],
            },

            formulaServices: {
              script: "",
              fields: [],
            },

            formulaProducts: {
              script: "",
              fields: [],
            },
          },
        ],
      };
      if (this.$refs.form) this.$refs.form.resetValidation();
      this.showDialog = true;
    },

    async addEnterprise(item) {
      //this.loadingCreation = true;
      this.saving = true;
      console.log("addEnterprise");
      console.log("addEnterprise" + JSON.stringify(item));
      //var c = await this.$dao.createEnterprise(item);
      var c = await hebelApi.enterprises.post(item);

      this.enterprises.push(item);
    },
    editEnterprise(item) {
      this.enterpriseEdit = Object.assign({}, item);
      this.showDialog = true;
    },
    closeModal() {
      this.$refs.form.resetValidation();
      this.showDialog = false;
    },
  },
};
</script>

<style scoped>
</style>